export const CONTEXT_MENU_CONTAINER_CLASSNAME = 'contextMenu__menu';
